import React from 'react';
import PropTypes from 'prop-types';
import PageLayout from '../../componentsV2/PageLayout/PageLayout';
import Button from '../../componentsV2/Button/Button';

const EmailVerificationExpiredPage = ({ flow = null }) => {
  if (flow === 'password_setup') {
    return (
      <PageLayout
        pageTitle="Invitation expired"
        shouldShowPageHeader
        shouldShowBreadcrumbs={false}
      >
        <div className="my-4 pl-2">
          <p className="mb-4 text-vamos-dark">
            This invitation has expired.
          </p>

          <p className="mb-6 text-vamos-dark">
            Please ask your Vamos administrator to re-send your account invitation.
          </p>
        </div>
      </PageLayout>
    );
  }
  return (
    <PageLayout
      pageTitle="Verification Link Expired"
      shouldShowPageHeader
      shouldShowBreadcrumbs={false}
    >
      <div className="my-4 pl-2">
        <p className="mb-4 text-vamos-dark">
          This verification link is invalid or has expired.
        </p>

        <p className="mb-6 text-vamos-dark">
          Please log in to your account and request a new email change.
        </p>

        <Button
          label="Go to Login"
          onClick={() => { window.location.href = '/users/sign_in'; }}
          color="action"
          size="lg"
          dataTestId="email-verification-go-login-button"
        />
      </div>
    </PageLayout>
  );
};

EmailVerificationExpiredPage.propTypes = {
  flow: PropTypes.oneOf(['password_setup']),
};

export default EmailVerificationExpiredPage;
